
<ion-split-pane when="lg" contentId="main" [class]="currentBg">
  <div contentId="main" [ngClass]="{'menu-main': menuOpened, 'menu-secondary': !menuOpened }"  id="myMenu" class="z-999 relative">
    <div class="relative pl-[36px] h-full">
      <div class="h-full" [ngClass]="{ ' border-r border-r-eggplant-100/[.25] ' : menuOpened !== false }" id="sideMenu">
        <app-sidemenu (toggleOpeneEvent)="toggleMenu($event)"></app-sidemenu>
      </div>
      <div class="absolute top-0 left-0 right-0 h-48 bg-gradient-to-b from-white to-transparent pointer-events-none"></div>
      <div class="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
    </div>
  </div>

  <div class="ion-page" id="main">
    <ion-router-outlet></ion-router-outlet>
    <app-tab></app-tab>
  </div>
</ion-split-pane>
